import React from "react";
import App from "./Components/App";
import { createRoot } from "react-dom/client";
import "./styles/App.scss";
import { AuthProvider } from "./firebaseContext";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
